"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ROLE_NAME_SHOW_CALLER = exports.ROLE_NAME_READ_ONLY = exports.ROLE_NAME_CONTRIBUTOR = exports.ROLE_NAME_ADMIN = void 0;
var ROLE_NAME_ADMIN = exports.ROLE_NAME_ADMIN = 'admin';
var ROLE_NAME_SHOW_CALLER = exports.ROLE_NAME_SHOW_CALLER = 'showCaller';
var ROLE_NAME_CONTRIBUTOR = exports.ROLE_NAME_CONTRIBUTOR = 'contributor';
var ROLE_NAME_READ_ONLY = exports.ROLE_NAME_READ_ONLY = 'readOnly';